import { AxisArrowIcon } from './AxisArrowIcon';

/**
 * author: Austin Andrews
 * id 3D0AC996-0A31-4D68-AD38-A8507967B269
 * name axis-arrow
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/axis-arrow.svg
 * tags
 * - Arrow 
 */
export const GyroIcon = AxisArrowIcon;
export default GyroIcon